import { formInput } from 'digicon-web-forms/forms';
import { i18n } from 'digicon-web-localization/localization';

const FIELDS = {
    'TXT': (data) => {
        return text(data);
    },
    'OPT': (data) => {
        return option(data);
    },
    'INT': (data) => {
        return number(data);
    },
    'DEC': (data) => {
        return number(data);
    },
    'OPT_DEP': (data) => {
        return option_dep(data, false);
    },
    'LABEL': (data) => {
        return label(data);
    },
    'IMAGE': (data) => {
        return image(data);
    },
    'FILE': (data) => {
        return file(data);
    },
    'BUTTON': (data) => {
        return button(data);
    },
    'CHK': (data) => {
        return checkBox(data);
    }
};


export function createFields(fieldData) {
    if (Object.keys(FIELDS).includes(fieldData.data_type)) {
        return FIELDS[fieldData.data_type](fieldData);
    } else {
        console.log(`Field type ${fieldData.type} not supported`);
        return null;
    }
}

export function createInfoField(data) {
    return {
        id: createValidId(data.category_en),
        label: data.locale === 'es-ES' ? data.category_es : data.category_en,
        group: createValidId(data.category_en),
        type: formInput.INFO
    };
}

function createBasicField(data, visible = true) {
    let label = data.locale === 'es-ES' ? data.name_es : data.name_en;
    if (data.unit && data.unit != "") {
        label = `${label} (${data.unit})`;
    }
    return {
        id: data.id,
        label: label,
        value: data.value ? data.value : '',
        group: createValidId(data.group),
        visible: visible
    };
}

function createDepField(data, group, visible = true) {
    return {
        value: data.value ? data.value : '',
        group: createValidId(group),
        visible: visible
    };
}

function text(data, visible = true) {
    let field = createBasicField(data, visible);
    field.type = formInput.TEXT;
    field.mandatory = data.mandatory;
    return [field];
}

function checkBox(data, visible = true) {
    let field = createBasicField(data, visible);
    field.type = formInput.CHECKBOX;
    field.label = data.locale === 'es-ES' ? data.name_es : data.name_en;
    return [field];
}

function option(data, visible = true) {
    let field = createBasicField(data, visible);
    const options = data.options.map(opt => ({ value: data.locale === 'es-ES' ? opt.text_es : opt.text_en, label: data.locale === 'es-ES' ? opt.text_es : opt.text_en }));
    field.type = formInput.SELECT;
    field.data = options;
    field.value = data.value;
    field.mandatory = data.mandatory;
    return [field];
}

function option_dep(data, visible = true) {
    const id = data.id_dep;
    const fields = [];
    for (var i = 0; i < data.options.length; i++) {
        let field = createDepField(data.options[i], data.group, visible);
        const options = data.options[i].dep_options.map(opt => ({ value: data.locale === 'es-ES' ? opt.text_es : opt.text_en, label: data.locale === 'es-ES' ? opt.text_es : opt.text_en }));
        field.type = formInput.SELECT;
        field.label = data.locale === 'es-ES' ? data.name_es : data.name_en,
            field.data = options;
        field.id = `${id}_${data.options[i].dep_value}`;
        field.mandatory = data.mandatory;
        fields.push(field);
    }
    return fields;
}

function number(data) {
    let field = createBasicField(data);
    field.type = formInput.NUMBER;
    field.mandatory = data.mandatory;
    if (data.rangeMax || data.rangeMin) {
        field.options = {};
        if (data.rangeMin) {
            field.options.min = data.rangeMin;
        }
        if (data.rangeMax) {
            field.options.max = data.rangeMax;
        }
    }
    if (data.rangeStep) {
        field.options.step = data.rangeStep;
    }
    if (!data.value && data.default) {
        field.value = parseFloat(data.default);
    }
    if (data.disabled || data.disabled == true) {
        field.readOnly = true;
        field.classList = ["disabled"]
    }
    return [field];
}

function label(data) {
    let field = createBasicField(data);
    field.label = data.text;
    field.type = formInput.LABEL;
    return [field];
}

function image(data) {
    let field = {
        id: data.id,
        label: '',
        value: `data:image/${data.ext};base64,${data.data}`,
        group: createValidId(data.group),
        type: formInput.IMAGE,
        readOnly: true
    };
    return [field];
}

function file(data) {
    let field = {
        id: data.id,
        label: data.text,
        group: createValidId(data.group),
        type: formInput.FILE
    };
    if (data.default) {
        field.data = [
            {
                label: 'accept',
                value: data.default
            }]
    }
    return [field];
}

function button(data) {
    let field = {
        id: data.id,
        label: i18n(data.text),
        group: createValidId(data.group),
        type: formInput.BUTTON
    };
    return [field];
}

function createValidId(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s/g, '').replace(/[^a-zA-Z ]/g, '');
}
